import { Host, h } from "@stencil/core";
/**
 * @slot - The first level items (entities) of the data model
 */
export class NextDataModeling {
    render() {
        return (h(Host, { key: 'a67bc2f25d96f5cb4a78a2624d7012bc5cf4e515', role: "list" }, h("slot", { key: '9c75dec25545eec64f0613bb629e12516221f050' })));
    }
    static get is() { return "ch-next-data-modeling"; }
    static get originalStyleUrls() {
        return {
            "$": ["next-data-modeling.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["next-data-modeling.css"]
        };
    }
}
